import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["aria-controls", "aria-label", "disabled"]
const _hoisted_2 = ["aria-controls", "aria-label", "onClick"]
const _hoisted_3 = { class: "sr-only" }
const _hoisted_4 = ["aria-controls", "aria-label", "disabled"]
const _hoisted_5 = ["aria-current"]
const _hoisted_6 = { class: "order-2 flex w-full flex-col px-4 py-8 lg:order-1 lg:w-1/2 lg:px-10" }
const _hoisted_7 = {
  key: 0,
  class: "justify-self-end"
}

import { ref, watchEffect, nextTick, computed, onMounted } from "vue";

import { getIcon } from "~/js/composables/icons";
import { getClasses } from "~/js/composables/classes";

import { Image } from "~/js/interfaces/media";

import TextH3 from "~/vue/atoms/texts/TextH3.vue";
import Prose from "~/vue/atoms/texts/TextProse.vue";
import ImageContent from "~/vue/atoms/images/ImageContent.vue";
import ButtonSecondary from "~/vue/atoms/buttons/ButtonSecondary.vue";

interface Card {
	background: string;
	heading: string;
	description: string;
	image: Image;
	link: any;
}

interface A11Y {
	title: string;
	previous: string;
	next: string;
}

interface Props {
	heading: string | null;
	headingColor?: string | null;
	cards: Card;
	a11y: A11Y;
	animate?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SliderCta',
  props: {
    heading: {},
    headingColor: { default: null },
    cards: {},
    a11y: {},
    animate: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const classes = ref({
	card: {
		display: `${props.cards.length > 1 ? "container" : ""} max-w-screen-xl`,
		flex: "flex flex-col lg:flex-row shrink-0",
		padding: "p-2",
		size: "w-[85vw] sm:w-[90vw] 2xl:w-screen",
		layout: "rounded-[30px]",
	},
	container: {
		animation: "transition-transform duration-700 ease-in-out",
		flex: "flex shrink-0",
		size: "w-screen",
	},
	controls: {
		flex: "flex items-center justify-end",
		space: "space-x-4",
	},
	dotsContainer: {
		display: "hidden sm:flex",
		space: "space-x-1",
	},
	dots: {
		animation: "transition-all",
		display: "inline-flex",
		background: "bg-viridian-500",
		layout: "rounded-full",
		size: "w-3 h-3",
	},
	header: {
		flex: "flex items-center justify-between",
		margin: "mb-4",
		size: "w-full",
		space: "space-x-2",
	},
	prevnext: {
		background: "bg-viridian-500",
		color: "text-white",
		display: "flex items-center justify-center",
		layout: "rounded-full",
		size: "w-8 h-8",
	},
	prevnextDisabled: {
		background: "bg-concrete-300",
		color: "text-white",
		display: "flex items-center justify-center",
		layout: "rounded-full",
		size: "w-8 h-8",
	},
	scroller: {
		flex: "flex shrink-0",
		oveflow: "scrollbar-hide scroll-smooth snap-mandatory snap-x overflow-x-auto",
		size: "w-screen",
	},
	wrapper: {
		flex: "flex justify-center relative",
		position: "relative",
	},
});
const ghost = ref<null | HTMLElement>(null);
const container = ref<null | HTMLElement>(null);
const scroller = ref<null | HTMLElement>(null);
const margin = ref(0);
// const translate = ref(0)
const activeSlide = ref(0);
const direction = ref("prev");
const reset = ref(false);

const updateSlide = (i: number, prevnext = true) => {
	if (i > activeSlide.value) {
		direction.value = "next";
	} else {
		direction.value = "prev";
	}

	activeSlide.value = i;
	setSpacings();

	if (prevnext) {
		prevNext();
	}

	reset.value = true;

	nextTick(() => {
		reset.value = false;
	});
};

const setSpacings = () => {
	margin.value = ghost.value?.getBoundingClientRect().left;
};

const prevNext = () => {
	const slide = ghost.value?.querySelectorAll(".slider-item")[1];

	if (slide) {
		// const padding = parseInt( (slide.currentStyle || window.getComputedStyle(slide)).paddingLeft ) * .5

		const position =
			direction.value == "prev"
				? scroller.value.scrollLeft - slide.offsetWidth
				: scroller.value.scrollLeft + slide.offsetWidth;

		scroller.value.scroll({
			left: slide.offsetWidth * activeSlide.value,
			top: 0,
			behavior: "smooth",
		});
		// translate.value = (slide?.getBoundingClientRect().width + padding) * (activeSlide.value - 1)
	}
};

const calculateActiveItem = () => {
	let setIndex = false;
	ghost.value.querySelectorAll(".slider-item").forEach((item) => {
		if (item.getBoundingClientRect().left >= 0 && !setIndex) {
			setIndex = true;
			const index = [...ghost.value.querySelectorAll(".slider-item")].indexOf(item);
			if (index !== activeSlide.value) {
				updateSlide(index, false);
			}
		}
	});
};

watchEffect(() => {
	if (scroller.value) {
		scroller.value.addEventListener("scroll", calculateActiveItem);
		calculateActiveItem();
		setSpacings();
	}
});

onMounted(() => {
	window.addEventListener("resize", () => {
		setSpacings();
	});

	setSpacings();

	setTimeout(() => {
		setSpacings();
	}, 300);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-full", __props.animate ? 'animate-slider' : ''])
  }, [
    _createElementVNode("header", {
      class: _normalizeClass(_unref(getClasses)(classes.value, 'header'))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(__props.animate ? 'animate-slider-items' : '')
      }, [
        (__props.heading)
          ? (_openBlock(), _createBlock(TextH3, {
              key: 0,
              utilities: __props.headingColor ?? undefined
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.heading), 1)
              ]),
              _: 1
            }, 8, ["utilities"]))
          : _createCommentVNode("", true)
      ], 2),
      (__props.cards.length > 1)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([_unref(getClasses)(classes.value, 'controls'), __props.animate ? 'animate-slider-items' : ''])
          }, [
            _createElementVNode("button", {
              "aria-controls": __props.a11y.title,
              "aria-label": __props.a11y.previous,
              disabled: activeSlide.value === 0,
              class: _normalizeClass(
						activeSlide.value === 0 ? _unref(getClasses)(classes.value, 'prevnextDisabled') : _unref(getClasses)(classes.value, 'prevnext')
					),
              onClick: _cache[0] || (_cache[0] = () => updateSlide(activeSlide.value > 0 ? activeSlide.value - 1 : activeSlide.value))
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(_unref(getIcon)('chevron-left'))
              }, null, 2)
            ], 10, _hoisted_1),
            _createElementVNode("div", {
              class: _normalizeClass(_unref(getClasses)(classes.value, 'dotsContainer'))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cards, (item, i) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: item.id,
                  "aria-controls": __props.a11y.title,
                  "aria-label": `${i} / ${__props.cards.length}`,
                  class: _normalizeClass([_unref(getClasses)(classes.value, 'dots'), i === activeSlide.value ? 'opacity-100' : 'opacity-20']),
                  onClick: () => updateSlide(i)
                }, [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(i) + " / " + _toDisplayString(__props.cards.length), 1)
                ], 10, _hoisted_2))
              }), 128))
            ], 2),
            _createElementVNode("button", {
              "aria-controls": __props.a11y.title,
              "aria-label": __props.a11y.next,
              disabled: activeSlide.value === __props.cards.length - 1,
              class: _normalizeClass(
						activeSlide.value === __props.cards.length - 1
							? _unref(getClasses)(classes.value, 'prevnextDisabled')
							: _unref(getClasses)(classes.value, 'prevnext')
					),
              onClick: _cache[1] || (_cache[1] = () => updateSlide(activeSlide.value < __props.cards.length + 1 ? activeSlide.value + 1 : activeSlide.value))
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(_unref(getIcon)('chevron-right'))
              }, null, 2)
            ], 10, _hoisted_4)
          ], 2))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      ref_key: "ghost",
      ref: ghost,
      class: _normalizeClass(_unref(getClasses)(classes.value, 'wrapper'))
    }, [
      _createElementVNode("div", {
        ref_key: "scroller",
        ref: scroller,
        class: _normalizeClass(_unref(getClasses)(classes.value, 'scroller')),
        style: _normalizeStyle({
					paddingRight: `${margin.value}px`,
				})
      }, [
        _createElementVNode("ul", {
          class: _normalizeClass([_unref(getClasses)(classes.value, 'container')]),
          style: _normalizeStyle({
						paddingLeft: `${margin.value}px`,
					}),
          "aria-roledescription": "carousel"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cards, (card, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: card.heading,
              class: _normalizeClass(["slider-item snap-center", [
							_unref(getClasses)(classes.value, 'card'),
							i > 0 ? 'ml-6 lg:ml-8' : '',
							card.background,
							__props.animate ? 'animate-slider-items' : '',
						]]),
              "aria-current": i + 1 === activeSlide.value,
              role: "listitem"
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(TextH3, { utilities: "block pb-4" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(card.heading), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(Prose, {
                  size: "large",
                  utilities: "block w-full grow",
                  html: card.description
                }, null, 8, ["html"]),
                (card.link.url)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(ButtonSecondary, {
                        href: card.link.url,
                        type: "a",
                        size: "small",
                        ga: {
										category: 'slider-cta',
										action: 'click',
										label: card.link.text,
									},
                        content: card.link.text,
                        target: card.link.target,
                        icon: card.link.isDownload ? 'download' : null,
                        "icon-position": "after",
                        utilities: "mt-4"
                      }, null, 8, ["href", "ga", "content", "target", "icon"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (card.image.srcset)
                ? (_openBlock(), _createBlock(ImageContent, {
                    key: 0,
                    image: card.image,
                    ratio: "w-full lg:h-full",
                    utilities: "w-full lg:w-1/2 order-1 lg:order-2",
                    position: "left",
                    loading: "lazy"
                  }, null, 8, ["image"]))
                : _createCommentVNode("", true)
            ], 10, _hoisted_5))
          }), 128)),
          (__props.cards.length > 1)
            ? (_openBlock(), _createElementBlock("li", {
                key: 0,
                class: "ml-0 shrink-0 grow-0 items-center sm:flex",
                style: _normalizeStyle({
							width: `${margin.value}px`,
						})
              }, null, 4))
            : _createCommentVNode("", true)
        ], 6)
      ], 6)
    ], 2)
  ], 2))
}
}

})